module.exports = __webpack_public_path__ + "assets/img/medin-icon.4cb5afdf.png";